import { faFeather } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { observer } from 'mobx-react-lite';
import React from 'react';
import { Link } from 'react-router-dom';

import { Pill } from '@feathr/components';
import { useLocalUrl, useStore } from '@feathr/extender/state';

interface IProps {
  id: string;
  linkToItem?: boolean;
}

function FlightChip({ id, linkToItem = true }: IProps) {
  const { Flights } = useStore();
  const localUrl = useLocalUrl();

  const flight = Flights.get(id);
  if (flight.isErrored) {
    return null;
  }

  if (flight.isPending) {
    return <Pill isLoading={true} />;
  }

  const content = (
    <Pill prefix={<FontAwesomeIcon icon={faFeather} />}>
      {flight.name}
      {flight.get('is_archived') ? ' (Archived)' : ''}
    </Pill>
  );

  if (linkToItem) {
    return <Link to={localUrl(flight.getItemUrl())}>{content}</Link>;
  }
  return content;
}

export default observer(FlightChip);
